export default "/images/cash.png?1e7f6f088ec12369d4f05981d2919e0e";